import Big from "big.js";

export class CalculationUtils {

    static round(amount: number, decimals: number = 2) {
        return Number(Big(amount).round(4).round(decimals).toFixed());
    }
}